let slots,
	threshold;

const DEFAULT_THRESHOLD = 300;

function init(lazyLoadThreshold = DEFAULT_THRESHOLD) {
	threshold = lazyLoadThreshold;
	slots = [];

	if (typeof threshold !== 'number' || isNaN(threshold)) {
		threshold = DEFAULT_THRESHOLD;
	}

	window.advert.pubsub.subscribe('scroll', _renderSlotsInView);
}

function addSlot(/** Slot */ slot) {
	if (!slot.lazyLoaded) {
		slot.render();

		return;
	}

	slots.push(slot);

	_renderSlotsInView();
}

function _renderSlotsInView() {
	slots = slots.filter((/** Slot */ slot) => {
		if (window.advert.screen.isInView(slot.node, threshold)) {
			slot.render();

			return false;
		}

		return true;
	});
}

module.exports = {
	init,
	addSlot
};
